import React from "react";
import {v4 as uuidv4} from 'uuid';

export const icons = {
	user: () => (
		<svg
			id="user"
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			x="0px"
			y="0px"
			viewBox="0 0 24 24"
			style={
				{
					"--iconPathOffsetBegin": 18,
					"--iconPathArrayBegin": 18,

					"--iconPathOffsetEnd": 0,
					"--iconPathArrayEnd": 18,

					"--iconCircleOffsetBegin": 70,
					"--iconCircleArrayBegin": 70,

					"--iconCircleOffsetEnd": 0,
					"--iconCircleArrayEnd": 70,

					"--iconCircle2OffsetBegin": 19,
					"--iconCircle2ArrayBegin": 19,

					"--iconCircle2OffsetEnd": 0,
					"--iconCircle2ArrayEnd": 19,
				} as React.CSSProperties
			}
		>
			<g id="icon" style={{ fill: "transparent" }} strokeWidth={1}>
				<circle cx="12" cy="12" r="11" style={{ stroke: "var(--iconColor)" }}></circle>
				<circle style={{ stroke: "var(--iconColor)" }} cx="12" cy="8" r="3" />
				<path style={{ stroke: "var(--iconColor)" }} d="M 6 18 C 6 15 9 13 12 13 C 15 13 18 15 18 18" strokeLinejoin="round" />
			</g>
		</svg>
	),

	arrowLeft: () => (
		<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g id="icon">
				<path d="M5 12H19M5 12L11 6M5 12L11 18" style={{ stroke: "var(--iconColor)" }} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"></path>
			</g>
		</svg>
	),

	circleArrowLeft: () => (
		<svg
			viewBox="0 0 24 24"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			style={
				{
					"--iconPathOffsetBegin": 18,
					"--iconPathArrayBegin": 18,

					"--iconPathOffsetEnd": 0,
					"--iconPathArrayEnd": 18,

					"--iconCircleOffsetBegin": 70,
					"--iconCircleArrayBegin": 70,

					"--iconCircleOffsetEnd": 0,
					"--iconCircleArrayEnd": 70,
				} as React.CSSProperties
			}
		>
			<g id="icon">
				<circle cx="12" cy="12" r="11" style={{ stroke: "var(--iconColor)" }} strokeWidth="1"></circle>
				<path d="M 18 12 L 6 12 L 10 8 M 18 12 L 6 12 L10 16" style={{ stroke: "var(--iconColor)" }} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"></path>
			</g>
		</svg>
	),

	check: () => (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={
				{
					"--iconPathOffsetBegin": 24,
					"--iconPathArrayBegin": 24,

					"--iconPathOffsetEnd": 0,
					"--iconPathArrayEnd": 24,
				} as React.CSSProperties
			}
		>
			<g id="icon">
				<path d="M4 12.6111L8.92308 17.5L20 6.5" style={{ stroke: "var(--iconColor)" }} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"></path>
			</g>
		</svg>
	),

	circleCheck: () => (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={
				{
					"--iconPathOffsetBegin": 10,
					"--iconPathArrayBegin": 10,

					"--iconPathOffsetEnd": 0,
					"--iconPathArrayEnd": 10,

					"--iconCircleOffsetBegin": 70,
					"--iconCircleArrayBegin": 70,

					"--iconCircleOffsetEnd": 0,
					"--iconCircleArrayEnd": 70,
				} as React.CSSProperties
			}
		>
			<g id="icon">
				<circle cx="12" cy="12" r="11" style={{ stroke: "var(--iconColor)" }} strokeWidth="1"></circle>
				<path d="M8.5 12.5L10.5 14.5L15.5 9.5" style={{ stroke: "var(--iconAccentColor)" }} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"></path>
			</g>
		</svg>
	),

	circleXMark: () => (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={
				{
					"--iconPathOffsetBegin": 12,
					"--iconPathArrayBegin": 12,

					"--iconPathOffsetEnd": 0,
					"--iconPathArrayEnd": 12,

					"--iconCircleOffsetBegin": 70,
					"--iconCircleArrayBegin": 70,

					"--iconCircleOffsetEnd": 0,
					"--iconCircleArrayEnd": 70,
				} as React.CSSProperties
			}
		>
			<g id="icon">
				<circle cx="12" cy="12" r="11" style={{ stroke: "var(--iconColor)" }} strokeWidth="1"></circle>
				<path d="M 15 9 L 9 15" style={{ stroke: "var(--iconColor)" }} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"></path>
				<path d="M 9 9 L 15 15" style={{ stroke: "var(--iconColor)" }} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"></path>
			</g>
		</svg>
	),
	logo: () => (
		<svg
			id="logo"
			x="0px"
			y="0px"
			viewBox="0 0 1000 616.66223"
			style={
				{
					fill: "var(--iconColor)",
					"--iconPathOffsetBegin": 100,
					"--iconPathArrayBegin": 700,

					"--iconPathOffsetEnd": 700,
					"--iconPathArrayEnd": 700,
				} as React.CSSProperties
			}
		>
			<g transform="matrix(6.6225166,0,0,6.6225166,0,-10.801325)">
				<path
					id="logo"
					d="m 49.387,1.131 c 9.022,0 16.336,7.357 16.336,16.432 v 0 L 65.72,38.245 c 1.294,2.113 2.042,4.601 2.042,7.265 0,7.659 -6.173,13.869 -13.788,13.869 -7.615,0 -13.788,-6.21 -13.788,-13.869 0,-7.66 6.173,-13.869 13.788,-13.869 3.983,0 7.57,1.699 10.087,4.415 v 0 -10e-4 L 64.065,17.563 C 64.063,9.41 57.492,2.8 49.387,2.8 41.281,2.8 34.71,9.41 34.71,17.564 v 0 0.08 c 1.246,1.058 2.038,2.64 2.038,4.409 v 0 V 58.1 H 34.71 v 19.715 c 0,9.074 -7.313,16.432 -16.335,16.432 -9.022,0 -16.336,-7.357 -16.336,-16.432 v 0 -1.817 C 0.792,74.939 0,73.355 0,71.588 v 0 -36.829 h 5.078 c 2.375,-1.949 5.406,-3.118 8.709,-3.118 7.615,0 13.788,6.209 13.788,13.869 0,7.659 -6.173,13.869 -13.788,13.869 -3.006,0 -5.787,-0.969 -8.053,-2.611 v 0 20.588 c -0.718,0 -1.405,-0.134 -2.038,-0.376 v 0 0.834 c 0,8.153 6.571,14.764 14.677,14.764 8.106,0 14.677,-6.61 14.677,-14.764 v 0 V 58.1 H 31.011 V 16.284 c 0.728,0 1.422,0.137 2.062,0.386 0.464,-8.66 7.59,-15.539 16.314,-15.539 z m 35.174,31.29 c 7.505,0 13.59,6.076 13.59,13.571 0,7.495 -6.085,13.571 -13.59,13.571 -7.506,0 -13.59,-6.076 -13.59,-13.571 -0.001,-7.495 6.084,-13.571 13.59,-13.571 z m 52.536,0 c 7.679,0 13.903,6.016 13.903,13.438 v 0 12.197 h -5.783 V 45.858 c 0,-4.335 -3.635,-7.849 -8.12,-7.849 -4.484,0 -8.12,3.514 -8.12,7.848 v 0 12.198 h -5.783 V 45.858 c 0,-4.335 -3.635,-7.849 -8.119,-7.849 -4.485,0 -8.121,3.514 -8.121,7.849 v 0 12.197 h -5.783 V 45.858 c 0,-7.422 6.225,-13.438 13.904,-13.438 4.482,0 8.469,2.051 11.011,5.234 2.542,-3.182 6.528,-5.233 11.011,-5.233 z m -52.536,5.645 c -4.384,0 -7.938,3.548 -7.938,7.926 0,4.377 3.554,7.926 7.938,7.926 4.383,0 7.937,-3.549 7.937,-7.926 -0.001,-4.378 -3.555,-7.926 -7.937,-7.926 z M 13.788,37.41 c -4.447,0 -8.053,3.627 -8.053,8.101 0,4.474 3.605,8.101 8.053,8.101 4.448,0 8.053,-3.627 8.053,-8.101 0,-4.474 -3.606,-8.101 -8.053,-8.101 z m 40.185,0 c -4.447,0 -8.052,3.627 -8.052,8.101 0,4.474 3.605,8.101 8.052,8.101 4.448,0 8.053,-3.627 8.053,-8.101 0,-4.474 -3.606,-8.101 -8.053,-8.101 z"
				/>
			</g>
		</svg>
	),

	star: () => (
		<svg
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={
				{
					"--iconPathOffsetBegin": 86,
					"--iconPathArrayBegin": 86,

					"--iconPathOffsetEnd": 0,
					"--iconPathArrayEnd": 86,

					"--iconCircleOffsetBegin": 145,
					"--iconCircleArrayBegin": 145,

					"--iconCircleOffsetEnd": 0,
					"--iconCircleArrayEnd": 145,
					"--animationDuration": "1s",
				} as React.CSSProperties
			}
		>
			<g id="star" style={{ stroke: "var(--iconColor)"}}>
				<circle cx="24" cy="24" r="23" style={{ stroke: "var(--iconColor)", strokeWidth:"calc(2 * var(--iconStrokeWidth)"}}></circle>
				<path style={{stroke: "var(--iconAccentColor)", strokeWidth:"calc(2 * var(--iconStrokeWidth)" }} d="M 25.1745 13.2082 l 2.6278 5.3246 c 0.1827 0.3703 0.5361 0.6269 0.9448 0.6862 l 5.8762 0.8539 c 2.4317 0.3781 2.3967 0.4831 0.6955 2.1399 l -4.252 4.1446 c -0.2955 0.2882 -0.4306 0.7037 -0.3606 1.1105 l 1.0036 5.8524 c 0.4042 2.5167 0.4222 2.5157 -1.8206 1.3229 l -5.2556 -2.7629 c -0.3655 -0.192 -0.8024 -0.192 -1.1679 0 l -5.2556 2.7629 c -2.2611 1.0428 -2.2441 1.0428 -1.8206 -1.3229 l 1.0036 -5.8524 c 0.07 -0.4068 -0.0651 -0.8223 -0.3606 -1.1105 l -4.252 -4.1446 c -1.9175 -1.8008 -1.8945 -1.7848 0.6955 -2.1399 l 5.8762 -0.8539 c 0.4087 -0.0593 0.762 -0.3159 0.9448 -0.6862 l 2.6278 -5.3246 C 24 11 24 11 25.1745 13.2082 z"></path>
			</g>
		</svg>
	),

	qr: () => (
		<svg style={{ fill: "var(--iconColor)" }} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
			<g>
				<g>
					<g>
						<path d="M0,0v233.739h233.739V0H0z M200.348,200.348H33.391V33.391h166.957V200.348z"></path>
					</g>
				</g>
				<g>
					<g>
						<rect x="66.783" y="66.783" width="100.174" height="100.174"></rect>
					</g>
				</g>
				<g>
					<g>
						<path d="M278.261,0v233.739H512V0H278.261z M478.609,200.348H311.652V33.391h166.957V200.348z"></path>
					</g>
				</g>
				<g>
					<g>
						<rect x="345.043" y="66.783" width="100.174" height="100.174"></rect>
					</g>
				</g>
				<g>
					<g>
						<path d="M0,278.261V512h233.739V278.261H0z M200.348,478.609H33.391V311.652h166.957V478.609z"></path>
					</g>
				</g>
				<g>
					<g>
						<rect x="66.783" y="345.043" width="100.174" height="100.174"></rect>
					</g>
				</g>
				<g>
					<g>
						<polygon points="345.043,311.652 345.043,278.261 278.261,278.261 278.261,512 345.043,512 345.043,478.609 311.652,478.609 311.652,411.826 345.043,411.826 345.043,378.435 311.652,378.435 311.652,311.652 "></polygon>
					</g>
				</g>
				<g>
					<g>
						<rect x="478.609" y="278.261" width="33.391" height="33.391"></rect>
					</g>
				</g>
				<g>
					<g>
						<polygon points="478.609,356.174 478.609,478.609 445.217,478.609 445.217,512 512,512 512,356.174 "></polygon>
					</g>
				</g>
				<g>
					<g>
						<rect x="378.435" y="278.261" width="66.783" height="33.391"></rect>
					</g>
				</g>
				<g>
					<g>
						<polygon points="445.217,378.435 445.217,345.043 378.435,345.043 378.435,445.217 445.217,445.217 445.217,411.826 411.826,411.826 411.826,378.435 "></polygon>
					</g>
				</g>
				<g>
					<g>
						<rect x="378.435" y="478.609" width="33.391" height="33.391"></rect>
					</g>
				</g>
			</g>
		</svg>
	),

	circleSimpleArrowLeft: () => (
		<svg
			viewBox="0 0 24 24"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			style={
				{
					"--iconPathOffsetBegin": 18,
					"--iconPathArrayBegin": 18,

					"--iconPathOffsetEnd": 0,
					"--iconPathArrayEnd": 18,

					"--iconCircleOffsetBegin": 70,
					"--iconCircleArrayBegin": 70,

					"--iconCircleOffsetEnd": 0,
					"--iconCircleArrayEnd": 70,
				} as React.CSSProperties
			}
		>
			<g id="icon">
				<circle cx="12" cy="12" r="11" style={{ stroke: "var(--iconColor)" }} strokeWidth="1"></circle>
				<path d="M 13 8 L 9 12 L 13 16" style={{ stroke: "var(--iconColor)" }} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"></path>
			</g>
		</svg>
	),

	hourglass: () => (
		<svg id="hourglass" viewBox="0 0 24 24" fill="none">
			<g id="icon-hourglass">
				<circle cx="12" cy="12" r="11" style={{ stroke: "var(--iconColor)" }} strokeWidth="1"></circle>
				<path d="M 9 6 L 15 6 Q 16 6 16 7 Q 16 8 13 12 Q 16 16 16 17 Q 16 18 15 18 L 9 18 Q 8 18 8 17 Q 8 16 11 12 Q 8 8 8 7 Q 8 6 9 6" style={{ stroke: "var(--iconColor)" }} strokeWidth={"0.5"} strokeLinecap="round" strokeLinejoin="round" />
			</g>
			<g id="icon-hourglass-sand_top">
				<path d="M 12 11 Q 8 7 10 7 L 14 7 Q 16 7 12 11" style={{ fill: "var(--iconAccentColor)" }} />
			</g>
			<g id="icon-hourglass-sand_bottom">
				<path d="M 12 11 Q 8 7 10 7 L 14 7 Q 16 7 12 11" style={{ fill: "var(--iconAccentColor)" }} />
			</g>
		</svg>
	),

	regulations: ()=> (
		<svg id="regulations" viewBox="0 0 24 24" fill="none">
			<g id="regulations_icon">
				<circle cx="12" cy="12" r="11" style={{ stroke: "var(--iconColor)" }} strokeWidth="1"></circle>
				<path d="M 9 6 L 15 6 C 17 6 17 6 17 8 L 17 17 C 17 19 17 19 15 19 L 9 19 C 7 19 7 19 7 17 L 7 8 C 7 6 7 6 9 6" style={{ stroke: "var(--iconAccentColor)" }} strokeWidth={"0.5"} strokeLinecap="round" strokeLinejoin="round" />
			</g>
			<g id="regulations_lines">
			<path d="M 9 9 L 15 9" style={{ stroke: "var(--iconAccentColor)" }} strokeWidth={"0.5"} strokeLinecap="round" strokeLinejoin="round" />
			<path d="M 9 11 L 14 11" style={{ stroke: "var(--iconAccentColor)" }} strokeWidth={"0.5"} strokeLinecap="round" strokeLinejoin="round" />
			<path d="M 9 13 L 15 13" style={{ stroke: "var(--iconAccentColor)" }} strokeWidth={"0.5"} strokeLinecap="round" strokeLinejoin="round" />
			<path d="M 9 15 L 14 15" style={{ stroke: "var(--iconAccentColor)" }} strokeWidth={"0.5"} strokeLinecap="round" strokeLinejoin="round" />
			</g>
			
		</svg>
	),
	percent: ()=>(
		<svg id="percent" viewBox="0 0 24 24" fill="none">
			<g id="percent_icon">
				<circle cx="12" cy="12" r="11" style={{ stroke: "var(--iconColor)" }} strokeWidth="1"></circle>
				<circle style={{ stroke: "var(--iconAccentColor)" }} cx="10" cy="9.5" r="1" />
				<circle style={{ stroke: "var(--iconAccentColor)" }} cx="14" cy="15.5" r="1" />
				<path d="M 9 16.5 L 15 8.5" style={{ stroke: "var(--iconAccentColor)" }} strokeWidth={"0.5"} strokeLinecap="round" strokeLinejoin="round" />
			</g>
			
		</svg>
	),
	eye: ()=>{
		const uuid = uuidv4();
		return (
			<svg id="eye" viewBox="0 0 24 24" fill="none">
				<g id="eye_icon" mask={`url(#eye_icon__mask__${uuid})`}>
					<circle style={{ stroke: "var(--iconAccentColor)" }} cx="12" cy="13" r="3" />
					<path d="M 1 13 C 5 9 8 6 12 6 C 16 6 19 9 23 13 C 19 17 16 20 12 20 C 8 20 5 17 1 13 " style={{ stroke: "var(--iconAccentColor)" }} strokeWidth={"1"} strokeLinecap="round" strokeLinejoin="round" />
					
				</g>
				<mask id={`eye_icon__mask__${uuid}`}>
						<rect x="0" y="0" width="24" height="24" fill="white"/>
						<path id="eye_icon_line" d="M 21 4 L 3 23" style={{ stroke: "black" }} strokeWidth={"6"} strokeLinecap="round" strokeLinejoin="round" />
				</mask>
				<g id="eye_icon__line">
					<path  d="M 21 4 L 3 23" style={{ stroke: "var(--iconAccentColor)" }} strokeWidth={"1"} strokeLinecap="round" strokeLinejoin="round" />
				</g>
			</svg>
		)
	},
	keyboard: ()=>{
		return (
			<svg id="keyboard" viewBox="0 0 24 24" fill="none">
				<g id="keyboard_shape">
					<path d="M 1 7 C 1 5 1 5 3 5 L 21 5 C 23 5 23 5 23 7 L 23 19 C 23 21 23 21 21 21 L 3 21 C 1 21 1 21 1 19 L 1 7 M 8 17 L 16 17 L 16 18 L 8 18 L 8 17 M 4 17 L 5 17 L 5 18 L 4 18 L 4 17 M 19 17 L 20 17 L 20 18 L 19 18 L 19 17 M 4 13 L 5 13 L 5 14 L 4 14 L 4 13 M 8 13 L 9 13 L 9 14 L 8 14 L 8 13 M 11.5 13 L 12.5 13 L 12.5 14 L 11.5 14 L 11.5 13 M 15 13 L 16 13 L 16 14 L 15 14 L 15 13 M 19 13 L 20 13 L 20 14 L 19 14 L 19 13 M 4 9 L 5 9 L 5 10 L 4 10 L 4 9 M 8 9 L 9 9 L 9 10 L 8 10 L 8 9 M 11.5 9 L 12.5 9 L 12.5 10 L 11.5 10 L 11.5 9 M 15 9 L 16 9 L 16 10 L 15 10 L 15 9 M 19 9 L 20 9 L 20 10 L 19 10 L 19 9" style={{ stroke: "var(--iconAccentColor)" }} strokeWidth={"1"} strokeLinecap="round" strokeLinejoin="round" />
					
				</g>
				
			</svg>
		)
	}
};

export type IconTypes = keyof typeof icons;
